import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { red } from "@mui/material/colors";

const ModalEntrevistaFechaHora = ({
  onClose,
  open,
  handleFunction,
  setDate,
  date = "", //solo edicion
  obtenerEntrevistas, //solo edicion
  isEditMode = false, //por defecto false
}) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>
        {isEditMode ? "Editar entrevista" : "Agendar entrevista"}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          Seleccione la fecha y la hora en la que se realizara la entrevista.
        </DialogContentText>
        <TextField
          onChange={(e) => {
            setDate(e.target.value);
            console.log("fecha", e.target.value);
          }}
          autoFocus
          value={date || ""}
          required
          type="datetime-local"
          fullWidth
          variant="standard"
          inputProps={{
            min: new Date().toISOString().slice(0, 16),
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button
          onClick={onClose}
          sx={{
            backgroundColor: "red",
            color: "white",
            "&:hover": { color: "red" },
            border: 1,
            borderColor: red,
          }}
        >
          Volver
        </Button>
        <Button
          onClick={(e) => {
            handleFunction(e);
            if (isEditMode) obtenerEntrevistas();
            onClose();
          }}
          sx={{
            backgroundColor: "#4ab2f3",
            color: "white",
            "&:hover": { color: "#4ab2f3" },
            border: 1,
            borderColor: "#4ab2f3",
          }}
        >
          Agendar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ModalEntrevistaFechaHora;
